/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 2933e1ecf371
 */

import * as z from "zod";
import {
  TransformationSummary,
  TransformationSummary$zodSchema,
} from "./transformationsummary.js";

export type TransformationListResponse = {
  transformations?: Array<TransformationSummary> | undefined;
  next_cursor?: string | null | undefined;
};

export const TransformationListResponse$zodSchema: z.ZodType<
  TransformationListResponse
> = z.object({
  next_cursor: z.string().nullable().optional(),
  transformations: z.array(TransformationSummary$zodSchema).optional(),
});
